<app-simple-select [inline]="inline" [autoOpen]="autoOpen"
                   [multiple]="multiple"
                   [allowEmpty]="allowEmpty"
                   [translationPrefix]="translationPrefix"
                   [selectList]="selectList"
                   [(selectedItems)]="selectedItems"
                   (selectedItemsChange)="updateData()">
</app-simple-select>
